// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ABUNDANCE_TALENT: {
    id: 207383,
    name: 'Abundance',
    icon: 'ability_druid_empoweredrejuvination',
    maxRanks: 1,
    entryIds: [128277],
    definitionIds: [{ id: 133084, specId: 105 }],
  },
  AESSINAS_RENEWAL_TALENT: {
    id: 474678,
    name: "Aessina's Renewal",
    icon: 'spell_nature_healingtouch',
    maxRanks: 1,
    entryIds: [128581],
    definitionIds: [{ id: 133384, specId: 105 }],
  },
  AETHERIAL_KINDLING_TALENT: {
    id: 327541,
    name: 'Aetherial Kindling',
    icon: 'ability_druid_starfall',
    maxRanks: 1,
    entryIds: [109843],
    definitionIds: [{ id: 114848, specId: 102 }],
  },
  AFTER_THE_WILDFIRE_TALENT: {
    id: 371905,
    name: 'After the Wildfire',
    icon: 'inv12_ability_druid_afterthewildfire',
    maxRanks: 1,
    entryIds: [103206],
    definitionIds: [{ id: 108211, specId: 104 }],
  },
  AGGRAVATE_WOUNDS_TALENT: {
    id: 441829,
    name: 'Aggravate Wounds',
    icon: 'artifactability_guardiandruid_goryfur',
    maxRanks: 1,
    entryIds: [117216],
    definitionIds: [{ id: 122228, specId: 104 }],
  },
  APEX_PREDATORS_CRAVING_TALENT: {
    id: 391881,
    name: "Apex Predator's Craving",
    icon: 'ability_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [103172],
    definitionIds: [{ id: 108177, specId: 103 }],
  },
  ARCANE_AFFINITY_TALENT: {
    id: 429540,
    name: 'Arcane Affinity',
    icon: 'spell_arcane_arcane01',
    maxRanks: 1,
    entryIds: [117178],
    definitionIds: [{ id: 122190, specId: 104 }],
  },
  ASCENDANT_ECLIPSES_1_BALANCE_TALENT: {
    id: 1261564,
    name: 'Ascendant Eclipses',
    icon: 'inv12_apextalent_druid_ascendanceeclipses',
    maxRanks: 1,
    entryIds: [137031],
    definitionIds: [{ id: 141794, specId: 102 }],
  },
  ASCENDANT_ECLIPSES_2_BALANCE_TALENT: {
    id: 1261565,
    name: 'Ascendant Eclipses',
    icon: 'inv12_apextalent_druid_ascendanceeclipses',
    maxRanks: 2,
    entryIds: [137030],
    definitionIds: [{ id: 141793, specId: 102 }],
  },
  ASCENDANT_ECLIPSES_3_BALANCE_TALENT: {
    id: 1261566,
    name: 'Ascendant Eclipses',
    icon: 'inv12_apextalent_druid_ascendanceeclipses',
    maxRanks: 1,
    entryIds: [137029],
    definitionIds: [{ id: 141792, specId: 102 }],
  },
  ASHAMANES_GUIDANCE_TALENT: {
    id: 391548,
    name: "Ashamane's Guidance",
    icon: 'spell_druid_incarnation',
    maxRanks: 1,
    entryIds: [103176],
    definitionIds: [{ id: 108181, specId: 103 }],
  },
  ASTRAL_COMMUNION_TALENT: {
    id: 450598,
    name: 'Astral Communion',
    icon: 'talentspec_druid_balance',
    maxRanks: 1,
    entryIds: [109850],
    definitionIds: [{ id: 114855, specId: 102 }],
  },
  ASTRAL_INFLUENCE_TALENT: {
    id: 197524,
    name: 'Astral Influence',
    icon: 'ability_skyreach_lens_flare',
    maxRanks: 1,
    entryIds: [103288],
    definitionIds: [{ id: 108293, specId: 105 }],
  },
  ASTRAL_INSIGHT_TALENT: {
    id: 429536,
    name: 'Astral Insight',
    icon: 'spell_druid_incarnation',
    maxRanks: 1,
    entryIds: [117772],
    definitionIds: [{ id: 122784, specId: 104 }],
  },
  ATMOSPHERIC_EXPOSURE_TALENT: {
    id: 429532,
    name: 'Atmospheric Exposure',
    icon: 'inv_cosmicvoid_nova',
    maxRanks: 1,
    entryIds: [117204],
    definitionIds: [{ id: 122216, specId: 104 }],
  },
  BALANCE_OF_ALL_THINGS_TALENT: {
    id: 394048,
    name: 'Balance of All Things',
    icon: 'ability_druid_earthandsky',
    maxRanks: 2,
    entryIds: [109848],
    definitionIds: [{ id: 114853, specId: 102 }],
  },
  BASK_IN_MOONLIGHT_TALENT: {
    id: 1271305,
    name: 'Bask in Moonlight',
    icon: 'spell_holy_elunesgrace',
    maxRanks: 1,
    entryIds: [135976],
    definitionIds: [{ id: 140731, specId: 104 }],
  },
  BERSERK_FERAL_TALENT: {
    id: 343223,
    name: 'Berserk',
    icon: 'ability_druid_berserk',
    maxRanks: 1,
    entryIds: [103162],
    definitionIds: [{ id: 108167, specId: 103 }],
  },
  BERSERK_GUARDIAN_TALENT: {
    id: 50334,
    name: 'Berserk',
    icon: 'ability_druid_berserk',
    maxRanks: 1,
    entryIds: [103216],
    definitionIds: [{ id: 108221, specId: 104 }],
  },
  BERSERK_HEART_OF_THE_LION_TALENT: {
    id: 391174,
    name: 'Berserk: Heart of the Lion',
    icon: 'ability_druid_primalprecision',
    maxRanks: 1,
    entryIds: [103161],
    definitionIds: [{ id: 108166, specId: 103 }],
  },
  BESTIAL_STRENGTH_TALENT: {
    id: 441841,
    name: 'Bestial Strength',
    icon: 'spell_nature_spiritarmor',
    maxRanks: 1,
    entryIds: [117208],
    definitionIds: [{ id: 122220, specId: 104 }],
  },
  BLOOD_FRENZY_TALENT: {
    id: 203962,
    name: 'Blood Frenzy',
    icon: 'ability_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [103209],
    definitionIds: [{ id: 108214, specId: 104 }],
  },
  BLOOD_SPATTERED_TALENT: {
    id: 1244532,
    name: 'Blood Spattered',
    icon: 'ability_druid_ferociousbite',
    maxRanks: 1,
    entryIds: [103149],
    definitionIds: [{ id: 108154, specId: 103 }],
  },
  BLOOMING_INFUSION_TALENT: {
    id: 429433,
    name: 'Blooming Infusion',
    icon: 'spell_nature_thorns',
    maxRanks: 1,
    entryIds: [117196],
    definitionIds: [{ id: 122208, specId: 105 }],
  },
  BOND_WITH_NATURE_TALENT: {
    id: 439929,
    name: 'Bond with Nature',
    icon: 'inv_misc_marrigolds_01',
    maxRanks: 1,
    entryIds: [117225],
    definitionIds: [{ id: 122237, specId: 105 }],
  },
  BOUNDLESS_MOONLIGHT_TALENT: {
    id: 424058,
    name: 'Boundless Moonlight',
    icon: 'inv_ability_eluneschosendruid_boundlessmoonlight',
    maxRanks: 1,
    entryIds: [117205],
    definitionIds: [{ id: 122217, specId: 104 }],
  },
  BOUNTEOUS_BLOOM_TALENT: {
    id: 429215,
    name: 'Bounteous Bloom',
    icon: 'inv_herbalism_70_dreamleaf',
    maxRanks: 1,
    entryIds: [117184],
    definitionIds: [{ id: 122196, specId: 105 }],
  },
  BRAMBLES_TALENT: {
    id: 203953,
    name: 'Brambles',
    icon: 'inv_misc_thornnecklace',
    maxRanks: 1,
    entryIds: [135570],
    definitionIds: [{ id: 140326, specId: 104 }],
  },
  BRISTLING_FUR_TALENT: {
    id: 155835,
    name: 'Bristling Fur',
    icon: 'spell_druid_bristlingfur',
    maxRanks: 1,
    entryIds: [103230],
    definitionIds: [{ id: 108235, specId: 104 }],
  },
  BURSTING_GROWTH_TALENT: {
    id: 440120,
    name: 'Bursting Growth',
    icon: 'inv_collections_armor_flowerbracelet_b_01',
    maxRanks: 1,
    entryIds: [135974],
    definitionIds: [{ id: 140729, specId: 105 }],
  },
  CALL_OF_THE_ELDER_DRUID_TALENT: {
    id: 426784,
    name: 'Call of the Elder Druid',
    icon: 'spell_unused2',
    maxRanks: 1,
    entryIds: [103123],
    definitionIds: [{ id: 108128, specId: 105 }],
  },
  CARNIVOROUS_INSTINCT_TALENT: {
    id: 390902,
    name: 'Carnivorous Instinct',
    icon: 'ability_mount_jungletiger',
    maxRanks: 2,
    entryIds: [103173],
    definitionIds: [{ id: 108178, specId: 103 }],
  },
  CELESTIAL_ALIGNMENT_TALENT: {
    id: 395022,
    name: 'Celestial Alignment',
    icon: 'spell_nature_natureguardian',
    maxRanks: 1,
    entryIds: [109849],
    definitionIds: [{ id: 114854, specId: 102 }],
  },
  CELESTIAL_FIRE_TALENT: {
    id: 1240185,
    name: 'Celestial Fire',
    icon: 'ability_mage_firestarter',
    maxRanks: 1,
    entryIds: [128231],
    definitionIds: [{ id: 133038, specId: 102 }],
  },
  CENARIUS_GUIDANCE_TALENT: {
    id: 393371,
    name: "Cenarius' Guidance",
    icon: 'ability_druid_treeoflife',
    maxRanks: 1,
    entryIds: [103118],
    definitionIds: [{ id: 108123, specId: 105 }],
  },
  CENARIUS_MIGHT_TALENT: {
    id: 455797,
    name: "Cenarius' Might",
    icon: 'achievement_reputation_guardiansofcenarius',
    maxRanks: 1,
    entryIds: [117199],
    definitionIds: [{ id: 122211, specId: 105 }],
  },
  CHOMP_TALENT: {
    id: 1244258,
    name: 'Chomp',
    icon: 'inv_1115_druid_jaguar',
    maxRanks: 1,
    entryIds: [134212],
    definitionIds: [{ id: 138990, specId: 103 }],
  },
  CIRCLE_OF_LIFE_AND_DEATH_TALENT: {
    id: 400320,
    name: 'Circle of Life and Death',
    icon: 'ability_druid_cyclone',
    maxRanks: 1,
    entryIds: [103152],
    definitionIds: [{ id: 108157, specId: 103 }],
  },
  CIRCLE_OF_THE_HEAVENS_TALENT: {
    id: 474541,
    name: 'Circle of the Heavens',
    icon: 'spell_druid_equinox',
    maxRanks: 1,
    entryIds: [128579],
    definitionIds: [{ id: 133382, specId: 105 }],
  },
  CIRCLE_OF_THE_WILD_TALENT: {
    id: 474530,
    name: 'Circle of the Wild',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [128580],
    definitionIds: [{ id: 133383, specId: 105 }],
  },
  CLAW_RAMPAGE_TALENT: {
    id: 441835,
    name: 'Claw Rampage',
    icon: 'ability_xavius_tormentingswipe',
    maxRanks: 1,
    entryIds: [117211],
    definitionIds: [{ id: 122223, specId: 104 }],
  },
  COILED_TO_SPRING_TALENT: {
    id: 449537,
    name: 'Coiled to Spring',
    icon: 'ability_druid_supriseattack',
    maxRanks: 1,
    entryIds: [103144],
    definitionIds: [{ id: 108149, specId: 103 }],
  },
  CONTROL_OF_THE_DREAM_TALENT: {
    id: 434249,
    name: 'Control of the Dream',
    icon: 'inv_cloth_outdooremeralddream_d_01_buckle',
    maxRanks: 1,
    entryIds: [117894],
    definitionIds: [{ id: 122906, specId: 105 }],
  },
  CONVOKE_THE_SPIRITS_TALENT: {
    id: 391528,
    name: 'Convoke the Spirits',
    icon: 'inv_ability_druid_convokethespirits',
    maxRanks: 1,
    entryIds: [109838, 103177, 103200, 103119],
    definitionIds: [
      { id: 114843, specId: 102 },
      { id: 108182, specId: 103 },
      { id: 108205, specId: 104 },
      { id: 108124, specId: 105 },
    ],
  },
  COSMIC_RAPIDITY_TALENT: {
    id: 400059,
    name: 'Cosmic Rapidity',
    icon: 'spell_druid_swarm',
    maxRanks: 2,
    entryIds: [109863],
    definitionIds: [{ id: 114868, specId: 102 }],
  },
  CULTIVATION_TALENT: {
    id: 200390,
    name: 'Cultivation',
    icon: 'spell_nature_healingtouch',
    maxRanks: 1,
    entryIds: [103110],
    definitionIds: [{ id: 108115, specId: 105 }],
  },
  CYCLONE_TALENT: {
    id: 33786,
    name: 'Cyclone',
    icon: 'spell_nature_earthbind',
    maxRanks: 1,
    entryIds: [128587],
    definitionIds: [{ id: 133390, specId: 105 }],
    manaCost: 3000,
  },
  DENIZEN_OF_THE_DREAM_TALENT: {
    id: 394065,
    name: 'Denizen of the Dream',
    icon: 'inv_faeriedragon2_orange',
    maxRanks: 1,
    entryIds: [133405],
    definitionIds: [{ id: 138191, specId: 102 }],
  },
  DOUBLE_CLAWED_RAKE_TALENT: {
    id: 391700,
    name: 'Double-Clawed Rake',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [103145],
    definitionIds: [{ id: 108150, specId: 103 }],
  },
  DREADFUL_BLEEDING_TALENT: {
    id: 391045,
    name: 'Dreadful Bleeding',
    icon: 'ability_ghoulfrenzy',
    maxRanks: 1,
    entryIds: [103182],
    definitionIds: [{ id: 108187, specId: 103 }],
  },
  DREADFUL_WOUND_TALENT: {
    id: 441809,
    name: 'Dreadful Wound',
    icon: 'artifactability_feraldruid_openwounds',
    maxRanks: 1,
    entryIds: [117220],
    definitionIds: [{ id: 122232, specId: 104 }],
  },
  DREAM_GUIDE_TALENT: {
    id: 1278886,
    name: 'Dream Guide',
    icon: 'achievement_reputation_guardiansofcenarius',
    maxRanks: 1,
    entryIds: [136806],
    definitionIds: [{ id: 141569, specId: 104 }],
  },
  DREAM_OF_CENARIUS_GUARDIAN_TALENT: {
    id: 372119,
    name: 'Dream of Cenarius',
    icon: 'ability_druid_dreamstate',
    maxRanks: 1,
    entryIds: [114698],
    definitionIds: [{ id: 119704, specId: 104 }],
  },
  DREAM_OF_CENARIUS_RESTORATION_TALENT: {
    id: 158504,
    name: 'Dream of Cenarius',
    icon: 'ability_druid_dreamstate',
    maxRanks: 1,
    entryIds: [103122],
    definitionIds: [{ id: 108127, specId: 105 }],
  },
  DREAM_SURGE_TALENT: {
    id: 433831,
    name: 'Dream Surge',
    icon: 'inv_ability_keeperofthegrovedruid_dreamsurge_fiendly',
    maxRanks: 1,
    entryIds: [117195],
    definitionIds: [{ id: 122207, specId: 105 }],
  },
  DRYADS_DANCE_TALENT: {
    id: 1264776,
    name: "Dryad's Dance",
    icon: 'inv_stave_2h_druid_a_01',
    maxRanks: 1,
    entryIds: [135971],
    definitionIds: [{ id: 140726, specId: 105 }],
  },
  DURABILITY_OF_NATURE_TALENT: {
    id: 429227,
    name: 'Durability of Nature',
    icon: 'ability_druid_manatree',
    maxRanks: 1,
    entryIds: [117200],
    definitionIds: [{ id: 122212, specId: 105 }],
  },
  EARLY_SPRING_TALENT: {
    id: 428937,
    name: 'Early Spring',
    icon: 'inv_misc_trailofflowers',
    maxRanks: 1,
    entryIds: [117895],
    definitionIds: [{ id: 122907, specId: 105 }],
  },
  ECLIPSE_TALENT: {
    id: 1239669,
    name: 'Eclipse',
    icon: 'ability_druid_eclipseorange',
    maxRanks: 1,
    entryIds: [109858],
    definitionIds: [{ id: 114863, specId: 102 }],
  },
  EFFLORESCENCE_TALENT: {
    id: 145205,
    name: 'Efflorescence',
    icon: 'inv_misc_herb_talandrasrose',
    maxRanks: 1,
    entryIds: [103111],
    definitionIds: [{ id: 108116, specId: 105 }],
    manaCost: 8500,
  },
  ELUNES_CHALLENGE_TALENT: {
    id: 1240283,
    name: "Elune's Challenge",
    icon: 'spell_nature_moonglow',
    maxRanks: 1,
    entryIds: [136831],
    definitionIds: [{ id: 141594, specId: 102 }],
  },
  ELUNES_FAVORED_TALENT: {
    id: 370586,
    name: "Elune's Favored",
    icon: 'spell_holy_elunesgrace',
    maxRanks: 1,
    entryIds: [103198],
    definitionIds: [{ id: 108203, specId: 104 }],
  },
  ELUNES_GRACE_TALENT: {
    id: 443046,
    name: "Elune's Grace",
    icon: 'spell_druid_wildcharge',
    maxRanks: 1,
    entryIds: [123304],
    definitionIds: [{ id: 128177, specId: 104 }],
  },
  ELUNES_GUIDANCE_TALENT: {
    id: 393991,
    name: "Elune's Guidance",
    icon: 'ability_ardenweald_druid',
    maxRanks: 1,
    entryIds: [109864],
    definitionIds: [{ id: 114869, specId: 102 }],
  },
  EMBRACE_OF_THE_DREAM_TALENT: {
    id: 392124,
    name: 'Embrace of the Dream',
    icon: 'ability_druid_healinginstincts',
    maxRanks: 1,
    entryIds: [103126],
    definitionIds: [{ id: 108131, specId: 105 }],
  },
  EMPOWERED_SHAPESHIFTING_TALENT: {
    id: 441689,
    name: 'Empowered Shapeshifting',
    icon: 'spell_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [117210],
    definitionIds: [{ id: 122222, specId: 104 }],
  },
  ENTANGLING_VORTEX_TALENT: {
    id: 439895,
    name: 'Entangling Vortex',
    icon: 'spell_druid_ursolsvortex',
    maxRanks: 1,
    entryIds: [117222],
    definitionIds: [{ id: 122234, specId: 105 }],
  },
  EVERBLOOM_1_RESTORATION_TALENT: {
    id: 392167,
    name: 'Everbloom',
    icon: 'inv12_apextalent_druid_everbloom',
    maxRanks: 1,
    entryIds: [137040],
    definitionIds: [{ id: 141803, specId: 105 }],
  },
  EVERBLOOM_2_RESTORATION_TALENT: {
    id: 1244331,
    name: 'Everbloom',
    icon: 'inv12_apextalent_druid_everbloom',
    maxRanks: 2,
    entryIds: [137039],
    definitionIds: [{ id: 141802, specId: 105 }],
  },
  EVERBLOOM_3_RESTORATION_TALENT: {
    id: 1244470,
    name: 'Everbloom',
    icon: 'inv12_apextalent_druid_everbloom',
    maxRanks: 1,
    entryIds: [137038],
    definitionIds: [{ id: 141801, specId: 105 }],
  },
  EXACERBATING_WOUNDS_TALENT: {
    id: 1271839,
    name: 'Exacerbating Wounds',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [117219],
    definitionIds: [{ id: 122231, specId: 104 }],
  },
  EXPANSIVENESS_TALENT: {
    id: 429399,
    name: 'Expansiveness',
    icon: 'spell_nature_abolishmagic',
    maxRanks: 1,
    entryIds: [117197],
    definitionIds: [{ id: 122209, specId: 105 }],
  },
  FELINE_SWIFTNESS_TALENT: {
    id: 131768,
    name: 'Feline Swiftness',
    icon: 'ability_druid_dash',
    maxRanks: 1,
    entryIds: [103314],
    definitionIds: [{ id: 108319, specId: 105 }],
  },
  FERAL_FRENZY_TALENT: {
    id: 274837,
    name: 'Feral Frenzy',
    icon: 'ability_druid_rake',
    maxRanks: 1,
    entryIds: [103175],
    definitionIds: [{ id: 108180, specId: 103 }],
    energyCost: 25,
  },
  FLASHING_CLAWS_TALENT: {
    id: 393427,
    name: 'Flashing Claws',
    icon: 'spell_druid_thrash',
    maxRanks: 2,
    entryIds: [103223],
    definitionIds: [{ id: 108228, specId: 104 }],
  },
  FLOURISH_TALENT: {
    id: 197721,
    name: 'Flourish',
    icon: 'spell_druid_wildburst',
    maxRanks: 1,
    entryIds: [103106],
    definitionIds: [{ id: 108111, specId: 105 }],
  },
  FLOWER_WALK_TALENT: {
    id: 439901,
    name: 'Flower Walk',
    icon: 'inv_misc_trailofflowers',
    maxRanks: 1,
    entryIds: [119855],
    definitionIds: [{ id: 124755, specId: 105 }],
  },
  FLUID_FORM_TALENT: {
    id: 449193,
    name: 'Fluid Form',
    icon: 'ability_druid_mastershapeshifter',
    maxRanks: 1,
    entryIds: [103326],
    definitionIds: [{ id: 108331, specId: 105 }],
  },
  FOCUSED_FRENZY_TALENT: {
    id: 1244544,
    name: 'Focused Frenzy',
    icon: 'ability_druid_ravage',
    maxRanks: 1,
    entryIds: [103174],
    definitionIds: [{ id: 108179, specId: 103 }],
  },
  FORCE_OF_NATURE_TALENT: {
    id: 205636,
    name: 'Force of Nature',
    icon: 'ability_druid_forceofnature',
    maxRanks: 1,
    entryIds: [109844],
    definitionIds: [{ id: 114849, specId: 102 }],
  },
  FORESTWALK_TALENT: {
    id: 400129,
    name: 'Forestwalk',
    icon: 'spell_lifegivingspeed',
    maxRanks: 2,
    entryIds: [103323],
    definitionIds: [{ id: 108328, specId: 105 }],
  },
  FOUNT_OF_STRENGTH_TALENT: {
    id: 441675,
    name: 'Fount of Strength',
    icon: 'spell_nature_unyeildingstamina',
    maxRanks: 1,
    entryIds: [117218],
    definitionIds: [{ id: 122230, specId: 104 }],
  },
  FRANTIC_FRENZY_TALENT: {
    id: 1243807,
    name: 'Frantic Frenzy',
    icon: 'ability_xavius_nightmareblades',
    maxRanks: 1,
    entryIds: [134211],
    definitionIds: [{ id: 138989, specId: 103 }],
    energyCost: 25,
  },
  FRANTIC_MOMENTUM_TALENT: {
    id: 391875,
    name: 'Frantic Momentum',
    icon: 'spell_druid_savagery',
    maxRanks: 2,
    entryIds: [103179],
    definitionIds: [{ id: 108184, specId: 103 }],
  },
  FRENZIED_REGENERATION_TALENT: {
    id: 22842,
    name: 'Frenzied Regeneration',
    icon: 'ability_bullrush',
    maxRanks: 1,
    entryIds: [103298],
    definitionIds: [{ id: 108303, specId: 105 }],
    rageCost: 10,
  },
  FRONT_OF_THE_PACK_TALENT: {
    id: 377835,
    name: 'Front of the Pack',
    icon: 'spell_druid_stampedingroar_cat',
    maxRanks: 1,
    entryIds: [103205],
    definitionIds: [{ id: 108210, specId: 104 }],
  },
  FURY_OF_ELUNE_TALENT: {
    id: 202770,
    name: 'Fury of Elune',
    icon: 'ability_druid_dreamstate',
    maxRanks: 1,
    entryIds: [109859],
    definitionIds: [{ id: 114864, specId: 102 }],
  },
  FURY_OF_NATURE_TALENT: {
    id: 370695,
    name: 'Fury of Nature',
    icon: 'ability_druid_cresentburn',
    maxRanks: 2,
    entryIds: [103203],
    definitionIds: [{ id: 108208, specId: 104 }],
  },
  GALACTIC_GUARDIAN_TALENT: {
    id: 203964,
    name: 'Galactic Guardian',
    icon: 'spell_frost_iceclaw',
    maxRanks: 1,
    entryIds: [103212],
    definitionIds: [{ id: 108217, specId: 104 }],
  },
  GALE_WINDS_TALENT: {
    id: 400142,
    name: 'Gale Winds',
    icon: 'ability_druid_galewinds',
    maxRanks: 1,
    entryIds: [128583],
    definitionIds: [{ id: 133386, specId: 105 }],
  },
  GERMINATION_TALENT: {
    id: 155675,
    name: 'Germination',
    icon: 'spell_druid_germination',
    maxRanks: 1,
    entryIds: [103127],
    definitionIds: [{ id: 108132, specId: 105 }],
  },
  GIFT_OF_AN_ANCIENT_GUARDIAN_TALENT: {
    id: 1251876,
    name: 'Gift of an Ancient Guardian',
    icon: 'inv_relics_idolofhealth',
    maxRanks: 1,
    entryIds: [135491],
    definitionIds: [{ id: 140248, specId: 104 }],
  },
  GIFT_OF_THE_WILD_TALENT: {
    id: 1262034,
    name: 'Gift of the Wild',
    icon: 'spell_nature_giftofthewild',
    maxRanks: 1,
    entryIds: [123794],
    definitionIds: [{ id: 128632, specId: 105 }],
  },
  GLISTENING_FUR_TALENT: {
    id: 429533,
    name: 'Glistening Fur',
    icon: 'ability_druid_ironfur',
    maxRanks: 1,
    entryIds: [117769],
    definitionIds: [{ id: 122781, specId: 104 }],
  },
  GORE_TALENT: {
    id: 210706,
    name: 'Gore',
    icon: 'spell_druid_bearhug',
    maxRanks: 1,
    entryIds: [103190],
    definitionIds: [{ id: 108195, specId: 104 }],
  },
  GORY_FUR_TALENT: {
    id: 200854,
    name: 'Gory Fur',
    icon: 'artifactability_guardiandruid_goryfur',
    maxRanks: 1,
    entryIds: [135566],
    definitionIds: [{ id: 140322, specId: 104 }],
  },
  GREEN_THUMB_TALENT: {
    id: 1270565,
    name: 'Green Thumb',
    icon: 'spell_lifegivingseed',
    maxRanks: 1,
    entryIds: [135975],
    definitionIds: [{ id: 140730, specId: 105 }],
  },
  GRIEVOUS_WOUNDS_TALENT: {
    id: 474526,
    name: 'Grievous Wounds',
    icon: 'ability_xavius_tormentingswipe',
    maxRanks: 1,
    entryIds: [103318],
    definitionIds: [{ id: 108323, specId: 105 }],
  },
  GROVES_INSPIRATION_TALENT: {
    id: 429402,
    name: "Grove's Inspiration",
    icon: 'ability_druid_protectionofthegrove',
    maxRanks: 1,
    entryIds: [117189],
    definitionIds: [{ id: 122201, specId: 105 }],
  },
  GROVE_GUARDIANS_TALENT: {
    id: 1226140,
    name: 'Grove Guardians',
    icon: 'ability_druid_forceofnature',
    maxRanks: 1,
    entryIds: [117104],
    definitionIds: [{ id: 122116, specId: 105 }],
  },
  GUARDIAN_OF_ELUNE_TALENT: {
    id: 155578,
    name: 'Guardian of Elune',
    icon: 'spell_druid_guardianofelune',
    maxRanks: 1,
    entryIds: [135569],
    definitionIds: [{ id: 140325, specId: 104 }],
  },
  HAIL_OF_STARS_TALENT: {
    id: 469004,
    name: 'Hail of Stars',
    icon: 'ability_druid_starfall',
    maxRanks: 1,
    entryIds: [128230],
    definitionIds: [{ id: 133037, specId: 102 }],
  },
  HARMONIOUS_BLOOMING_TALENT: {
    id: 392256,
    name: 'Harmonious Blooming',
    icon: 'inv_misc_herb_felblossom',
    maxRanks: 1,
    entryIds: [103134],
    definitionIds: [{ id: 108139, specId: 105 }],
  },
  HARMONIOUS_CONSTITUTION_TALENT: {
    id: 440116,
    name: 'Harmonious Constitution',
    icon: 'talentspec_druid_restoration',
    maxRanks: 1,
    entryIds: [119854],
    definitionIds: [{ id: 124754, specId: 105 }],
  },
  HARMONY_OF_THE_GROVE_TALENT: {
    id: 428731,
    name: 'Harmony of the Grove',
    icon: 'ability_druid_forceofnature',
    maxRanks: 1,
    entryIds: [117203],
    definitionIds: [{ id: 122215, specId: 105 }],
  },
  HARMONY_OF_THE_HEAVENS_TALENT: {
    id: 450558,
    name: 'Harmony of the Heavens',
    icon: 'spell_arcane_massdispel',
    maxRanks: 1,
    entryIds: [133404],
    definitionIds: [{ id: 138190, specId: 102 }],
  },
  HARNESSED_RAGE_TALENT: {
    id: 1253035,
    name: 'Harnessed Rage',
    icon: 'inv_misc_bearclaw_nightmare',
    maxRanks: 1,
    entryIds: [135490],
    definitionIds: [{ id: 140247, specId: 104 }],
  },
  HEART_OF_THE_WILD_TALENT: {
    id: 1261867,
    name: 'Heart of the Wild',
    icon: 'spell_holy_blessingofagility',
    maxRanks: 1,
    entryIds: [103309],
    definitionIds: [{ id: 108314, specId: 105 }],
  },
  HIBERNATE_TALENT: {
    id: 2637,
    name: 'Hibernate',
    icon: 'spell_nature_sleep',
    maxRanks: 1,
    entryIds: [103289],
    definitionIds: [{ id: 108294, specId: 105 }],
    manaCost: 3000,
  },
  HUNGER_FOR_BATTLE_TALENT: {
    id: 1244547,
    name: 'Hunger for Battle',
    icon: 'ability_druid_predatoryinstincts',
    maxRanks: 1,
    entryIds: [103156],
    definitionIds: [{ id: 108161, specId: 103 }],
  },
  HUNT_BENEATH_THE_OPEN_SKIES_TALENT: {
    id: 439868,
    name: 'Hunt Beneath the Open Skies',
    icon: 'spell_druid_lunarinspiration',
    maxRanks: 1,
    entryIds: [117231],
    definitionIds: [{ id: 122243, specId: 105 }],
  },
  IMPLANT_TALENT: {
    id: 440118,
    name: 'Implant',
    icon: 'ability_creature_poison_03',
    maxRanks: 1,
    entryIds: [117229],
    definitionIds: [{ id: 122241, specId: 105 }],
  },
  IMPROVED_BARKSKIN_TALENT: {
    id: 327993,
    name: 'Improved Barkskin',
    icon: 'spell_nature_stoneclawtotem',
    maxRanks: 1,
    entryIds: [128591],
    definitionIds: [{ id: 133394, specId: 105 }],
  },
  IMPROVED_ECLIPSE_TALENT: {
    id: 1240906,
    name: 'Improved Eclipse',
    icon: 'ability_druid_eclipseorange',
    maxRanks: 1,
    entryIds: [115458],
    definitionIds: [{ id: 120470, specId: 102 }],
  },
  IMPROVED_IRONBARK_TALENT: {
    id: 382552,
    name: 'Improved Ironbark',
    icon: 'spell_druid_ironbark',
    maxRanks: 1,
    entryIds: [103139],
    definitionIds: [{ id: 108144, specId: 105 }],
  },
  IMPROVED_NATURES_CURE_TALENT: {
    id: 392378,
    name: "Improved Nature's Cure",
    icon: 'ability_shaman_cleansespirit',
    maxRanks: 1,
    entryIds: [128590],
    definitionIds: [{ id: 133393, specId: 105 }],
  },
  IMPROVED_REGROWTH_TALENT: {
    id: 231032,
    name: 'Improved Regrowth',
    icon: 'spell_nature_resistnature',
    maxRanks: 1,
    entryIds: [103142],
    definitionIds: [{ id: 108147, specId: 105 }],
  },
  IMPROVED_STAMPEDING_ROAR_TALENT: {
    id: 288826,
    name: 'Improved Stampeding Roar',
    icon: 'spell_druid_stamedingroar',
    maxRanks: 1,
    entryIds: [103308],
    definitionIds: [{ id: 108313, specId: 105 }],
  },
  IMPROVED_SWIFTMEND_TALENT: {
    id: 470549,
    name: 'Improved Swiftmend',
    icon: 'ability_druid_empoweredtouch',
    maxRanks: 1,
    entryIds: [128274],
    definitionIds: [{ id: 133081, specId: 105 }],
  },
  IMPROVED_WILD_GROWTH_TALENT: {
    id: 328025,
    name: 'Improved Wild Growth',
    icon: 'ability_druid_flourish',
    maxRanks: 1,
    entryIds: [103096],
    definitionIds: [{ id: 108101, specId: 105 }],
  },
  INCAPACITATING_ROAR_TALENT: {
    id: 99,
    name: 'Incapacitating Roar',
    icon: 'ability_druid_demoralizingroar',
    maxRanks: 1,
    entryIds: [103316],
    definitionIds: [{ id: 108321, specId: 105 }],
  },
  INCARNATION_AVATAR_OF_ASHAMANE_TALENT: {
    id: 102543,
    name: 'Incarnation: Avatar of Ashamane',
    icon: 'spell_druid_incarnation',
    maxRanks: 1,
    entryIds: [103178],
    definitionIds: [{ id: 108183, specId: 103 }],
  },
  INCARNATION_CHOSEN_OF_ELUNE_TALENT: {
    id: 394013,
    name: 'Incarnation: Chosen of Elune',
    icon: 'spell_druid_incarnation',
    maxRanks: 1,
    entryIds: [109839],
    definitionIds: [{ id: 114844, specId: 102 }],
  },
  INCARNATION_GUARDIAN_OF_URSOC_TALENT: {
    id: 102558,
    name: 'Incarnation: Guardian of Ursoc',
    icon: 'spell_druid_incarnation',
    maxRanks: 1,
    entryIds: [103201],
    definitionIds: [{ id: 108206, specId: 104 }],
  },
  INCARNATION_TREE_OF_LIFE_TALENT: {
    id: 33891,
    name: 'Incarnation: Tree of Life',
    icon: 'ability_druid_improvedtreeform',
    maxRanks: 1,
    entryIds: [103120],
    definitionIds: [{ id: 108125, specId: 105 }],
  },
  INCESSANT_TEMPEST_TALENT: {
    id: 400140,
    name: 'Incessant Tempest',
    icon: 'ability_skyreach_wind',
    maxRanks: 1,
    entryIds: [128582],
    definitionIds: [{ id: 133385, specId: 105 }],
  },
  INFECTED_WOUNDS_FERAL_TALENT: {
    id: 48484,
    name: 'Infected Wounds',
    icon: 'ability_druid_infectedwound',
    maxRanks: 1,
    entryIds: [103147],
    definitionIds: [{ id: 108152, specId: 103 }],
  },
  INFECTED_WOUNDS_GUARDIAN_TALENT: {
    id: 345208,
    name: 'Infected Wounds',
    icon: 'ability_druid_infectedwound',
    maxRanks: 1,
    entryIds: [135567],
    definitionIds: [{ id: 140323, specId: 104 }],
  },
  INNATE_RESOLVE_TALENT: {
    id: 377811,
    name: 'Innate Resolve',
    icon: 'spell_nature_healingway',
    maxRanks: 1,
    entryIds: [103229],
    definitionIds: [{ id: 108234, specId: 104 }],
  },
  INNERVATE_TALENT: {
    id: 29166,
    name: 'Innervate',
    icon: 'spell_nature_lightning',
    maxRanks: 1,
    entryIds: [103324],
    definitionIds: [{ id: 108329, specId: 105 }],
  },
  INNER_PEACE_TALENT: {
    id: 197073,
    name: 'Inner Peace',
    icon: 'ability_druid_dreamstate',
    maxRanks: 1,
    entryIds: [103107],
    definitionIds: [{ id: 108112, specId: 105 }],
  },
  INSTINCTS_OF_THE_CLAW_TALENT: {
    id: 449184,
    name: 'Instincts of the Claw',
    icon: 'spell_shadow_vampiricaura',
    maxRanks: 1,
    entryIds: [128585],
    definitionIds: [{ id: 133388, specId: 105 }],
  },
  INTENSITY_TALENT: {
    id: 1264649,
    name: 'Intensity',
    icon: 'spell_frost_windwalkon',
    maxRanks: 1,
    entryIds: [103105],
    definitionIds: [{ id: 108110, specId: 105 }],
  },
  IRONBARK_TALENT: {
    id: 102342,
    name: 'Ironbark',
    icon: 'spell_druid_ironbark',
    maxRanks: 1,
    entryIds: [103141],
    definitionIds: [{ id: 108146, specId: 105 }],
  },
  IRONFUR_TALENT: {
    id: 192081,
    name: 'Ironfur',
    icon: 'ability_druid_ironfur',
    maxRanks: 1,
    entryIds: [103305],
    definitionIds: [{ id: 108310, specId: 105 }],
    rageCost: 40,
  },
  KILLER_INSTINCT_TALENT: {
    id: 108299,
    name: 'Killer Instinct',
    icon: 'ability_druid_predatoryinstincts',
    maxRanks: 2,
    entryIds: [103303],
    definitionIds: [{ id: 108308, specId: 105 }],
  },
  KILLING_BLOW_TALENT: {
    id: 1252994,
    name: 'Killing Blow',
    icon: 'artifactability_feraldruid_ashamanesbite',
    maxRanks: 1,
    entryIds: [103222],
    definitionIds: [{ id: 108227, specId: 104 }],
  },
  KILLING_STRIKES_TALENT: {
    id: 441824,
    name: 'Killing Strikes',
    icon: 'ability_druid_kingofthejungle',
    maxRanks: 1,
    entryIds: [136624],
    definitionIds: [{ id: 141396, specId: 104 }],
  },
  LACERATING_CLAWS_TALENT: {
    id: 1244632,
    name: 'Lacerating Claws',
    icon: 'spell_druid_bloodythrash',
    maxRanks: 1,
    entryIds: [103157],
    definitionIds: [{ id: 108162, specId: 103 }],
  },
  LETHAL_PRESERVATION_TALENT: {
    id: 455461,
    name: 'Lethal Preservation',
    icon: 'spell_nature_healingtouch',
    maxRanks: 1,
    entryIds: [117224],
    definitionIds: [{ id: 122236, specId: 105 }],
  },
  LIFEBLOOM_TALENT: {
    id: 33763,
    name: 'Lifebloom',
    icon: 'inv_misc_herb_felblossom',
    maxRanks: 1,
    entryIds: [103100],
    definitionIds: [{ id: 108105, specId: 105 }],
    manaCost: 4000,
  },
  LIFETREADING_TALENT: {
    id: 1217941,
    name: 'Lifetreading',
    icon: 'inv12_ability_druid_lifetreading',
    maxRanks: 1,
    entryIds: [128708],
    definitionIds: [{ id: 133510, specId: 105 }],
  },
  LIGHT_OF_THE_SUN_TALENT: {
    id: 202918,
    name: 'Light of the Sun',
    icon: 'ability_vehicle_sonicshockwave',
    maxRanks: 1,
    entryIds: [128588],
    definitionIds: [{ id: 133391, specId: 102 }],
  },
  LIMB_FROM_LIMB_TALENT: {
    id: 1271540,
    name: 'Limb from Limb',
    icon: 'artifactability_feraldruid_ashamanesbite',
    maxRanks: 1,
    entryIds: [135980],
    definitionIds: [{ id: 140735, specId: 104 }],
  },
  LINGERING_HEALING_TALENT: {
    id: 231040,
    name: 'Lingering Healing',
    icon: 'spell_nature_rejuvenation',
    maxRanks: 1,
    entryIds: [103319],
    definitionIds: [{ id: 108324, specId: 105 }],
  },
  LIVELINESS_TALENT: {
    id: 426702,
    name: 'Liveliness',
    icon: 'spell_druid_symbiosis',
    maxRanks: 1,
    entryIds: [103130],
    definitionIds: [{ id: 108135, specId: 105 }],
  },
  LORE_OF_THE_GROVE_TALENT: {
    id: 449185,
    name: 'Lore of the Grove',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [128584],
    definitionIds: [{ id: 133387, specId: 105 }],
  },
  LUNAR_BEAM_TALENT: {
    id: 204066,
    name: 'Lunar Beam',
    icon: 'spell_nature_moonglow',
    maxRanks: 1,
    entryIds: [114700],
    definitionIds: [{ id: 119706, specId: 104 }],
  },
  LUNAR_CALLING_TALENT: {
    id: 429523,
    name: 'Lunar Calling',
    icon: 'ability_druid_cresentburn',
    maxRanks: 1,
    entryIds: [117183],
    definitionIds: [{ id: 122195, specId: 104 }],
  },
  LUNAR_INSIGHT_TALENT: {
    id: 429530,
    name: 'Lunar Insight',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [117181],
    definitionIds: [{ id: 122193, specId: 104 }],
  },
  LUNAR_INSPIRATION_TALENT: {
    id: 155580,
    name: 'Lunar Inspiration',
    icon: 'spell_druid_lunarinspiration',
    maxRanks: 1,
    entryIds: [103170],
    definitionIds: [{ id: 108175, specId: 103 }],
  },
  LUNATION_TALENT: {
    id: 429539,
    name: 'Lunation',
    icon: 'spell_nature_moonglow',
    maxRanks: 1,
    entryIds: [117177],
    definitionIds: [{ id: 122189, specId: 104 }],
  },
  LYCARAS_INSPIRATION_TALENT: {
    id: 1232897,
    name: "Lycara's Inspiration",
    icon: 'inv_trinket_ardenweald_02_yellow',
    maxRanks: 1,
    entryIds: [114300],
    definitionIds: [{ id: 119305, specId: 105 }],
  },
  LYCARAS_TEACHINGS_TALENT: {
    id: 378988,
    name: "Lycara's Teachings",
    icon: 'inv_trinket_ardenweald_02_green',
    maxRanks: 2,
    entryIds: [103311],
    definitionIds: [{ id: 108316, specId: 105 }],
  },
  MAIM_TALENT: {
    id: 22570,
    name: 'Maim',
    icon: 'ability_druid_mangle',
    maxRanks: 1,
    entryIds: [103299],
    definitionIds: [{ id: 108304, specId: 105 }],
    energyCost: 30,
    comboPointsCost: 1,
  },
  MASS_ENTANGLEMENT_TALENT: {
    id: 102359,
    name: 'Mass Entanglement',
    icon: 'spell_druid_massentanglement',
    maxRanks: 1,
    entryIds: [103285],
    definitionIds: [{ id: 108290, specId: 105 }],
  },
  MASTER_SHAPESHIFTER_TALENT: {
    id: 289237,
    name: 'Master Shapeshifter',
    icon: 'ability_druid_mastershapeshifter',
    maxRanks: 1,
    entryIds: [114809],
    definitionIds: [{ id: 119816, specId: 105 }],
  },
  MATTED_FUR_TALENT: {
    id: 385786,
    name: 'Matted Fur',
    icon: 'inv_misc_pelt_15',
    maxRanks: 2,
    entryIds: [123796],
    definitionIds: [{ id: 128634, specId: 105 }],
  },
  MAUL_TALENT: {
    id: 6807,
    name: 'Maul',
    icon: 'ability_druid_maul',
    maxRanks: 1,
    entryIds: [103191],
    definitionIds: [{ id: 108196, specId: 104 }],
    rageCost: 40,
  },
  MEMORY_OF_YSERA_TALENT: {
    id: 1250906,
    name: 'Memory of Ysera',
    icon: 'spell_nature_regeneration_02',
    maxRanks: 2,
    entryIds: [103211],
    definitionIds: [{ id: 108216, specId: 104 }],
  },
  MERCILESS_CLAWS_TALENT: {
    id: 231063,
    name: 'Merciless Claws',
    icon: 'inv_misc_monsterclaw_03',
    maxRanks: 1,
    entryIds: [103159],
    definitionIds: [{ id: 108164, specId: 103 }],
  },
  METEORITES_TALENT: {
    id: 1240907,
    name: 'Meteorites',
    icon: 'ability_druid_starfall',
    maxRanks: 1,
    entryIds: [109868],
    definitionIds: [{ id: 114873, specId: 102 }],
  },
  METEOR_STORM_TALENT: {
    id: 1240262,
    name: 'Meteor Storm',
    icon: 'spell_arcane_starfire',
    maxRanks: 1,
    entryIds: [133406],
    definitionIds: [{ id: 138192, specId: 102 }],
  },
  MIGHTY_BASH_TALENT: {
    id: 5211,
    name: 'Mighty Bash',
    icon: 'ability_druid_bash',
    maxRanks: 1,
    entryIds: [103315],
    definitionIds: [{ id: 108320, specId: 105 }],
  },
  MOMENT_OF_CLARITY_TALENT: {
    id: 236068,
    name: 'Moment of Clarity',
    icon: 'spell_druid_momentofclarity',
    maxRanks: 1,
    entryIds: [103167],
    definitionIds: [{ id: 108172, specId: 103 }],
  },
  MOONDUST_TALENT: {
    id: 429538,
    name: 'Moondust',
    icon: 'inv_enchant_dust',
    maxRanks: 1,
    entryIds: [117192],
    definitionIds: [{ id: 122204, specId: 104 }],
  },
  MOONKIN_FORM_TALENT: {
    id: 24858,
    name: 'Moonkin Form',
    icon: 'spell_nature_forceofnature',
    maxRanks: 1,
    entryIds: [103286],
    definitionIds: [{ id: 108291, specId: 105 }],
  },
  MOONLESS_NIGHT_TALENT: {
    id: 400278,
    name: 'Moonless Night',
    icon: 'artifactability_balancedruid_newmoon',
    maxRanks: 1,
    entryIds: [114699],
    definitionIds: [{ id: 119705, specId: 104 }],
  },
  MOON_GUARDIAN_TALENT: {
    id: 429520,
    name: 'Moon Guardian',
    icon: 'spell_nature_moonglow',
    maxRanks: 1,
    entryIds: [117193],
    definitionIds: [{ id: 122205, specId: 104 }],
  },
  NATURAL_RECOVERY_TALENT: {
    id: 377796,
    name: 'Natural Recovery',
    icon: 'ability_druid_naturalperfection',
    maxRanks: 1,
    entryIds: [103284],
    definitionIds: [{ id: 108289, specId: 105 }],
  },
  NATURAL_RESILIENCE_TALENT: {
    id: 1278789,
    name: 'Natural Resilience',
    icon: 'spell_lfieblood',
    maxRanks: 1,
    entryIds: [103225],
    definitionIds: [{ id: 108230, specId: 104 }],
  },
  NATURES_BALANCE_TALENT: {
    id: 202430,
    name: "Nature's Balance",
    icon: 'ability_druid_balanceofpower',
    maxRanks: 1,
    entryIds: [109862],
    definitionIds: [{ id: 114867, specId: 102 }],
  },
  NATURES_BOUNTY_TALENT: {
    id: 1263879,
    name: "Nature's Bounty",
    icon: 'talentspec_druid_restoration',
    maxRanks: 1,
    entryIds: [103128],
    definitionIds: [{ id: 108133, specId: 105 }],
  },
  NATURES_GRACE_TALENT: {
    id: 450347,
    name: "Nature's Grace",
    icon: 'ability_druid_lunarguidance',
    maxRanks: 1,
    entryIds: [136832],
    definitionIds: [{ id: 141595, specId: 102 }],
  },
  NATURES_SPLENDOR_TALENT: {
    id: 392288,
    name: "Nature's Splendor",
    icon: 'spell_nature_spiritarmor',
    maxRanks: 1,
    entryIds: [103103],
    definitionIds: [{ id: 108108, specId: 105 }],
  },
  NATURES_SWIFTNESS_TALENT: {
    id: 132158,
    name: "Nature's Swiftness",
    icon: 'spell_nature_ravenform',
    maxRanks: 1,
    entryIds: [103101],
    definitionIds: [{ id: 108106, specId: 105 }],
  },
  NEW_MOON_TALENT: {
    id: 274281,
    name: 'New Moon',
    icon: 'artifactability_balancedruid_newmoon',
    maxRanks: 1,
    entryIds: [109860],
    definitionIds: [{ id: 114865, specId: 102 }],
  },
  NURTURING_DORMANCY_TALENT: {
    id: 392099,
    name: 'Nurturing Dormancy',
    icon: 'ability_druid_replenish',
    maxRanks: 1,
    entryIds: [103132],
    definitionIds: [{ id: 108137, specId: 105 }],
  },
  NURTURING_INSTINCT_TALENT: {
    id: 33873,
    name: 'Nurturing Instinct',
    icon: 'ability_druid_healinginstincts',
    maxRanks: 2,
    entryIds: [103292],
    definitionIds: [{ id: 108297, specId: 105 }],
  },
  OAKSKIN_TALENT: {
    id: 449191,
    name: 'Oakskin',
    icon: 'spell_nature_stoneclawtotem',
    maxRanks: 1,
    entryIds: [123795],
    definitionIds: [{ id: 128633, specId: 105 }],
  },
  OMEN_OF_CLARITY_FERAL_TALENT: {
    id: 16864,
    name: 'Omen of Clarity',
    icon: 'spell_nature_crystalball',
    maxRanks: 1,
    entryIds: [103187],
    definitionIds: [{ id: 108192, specId: 103 }],
  },
  OMEN_OF_CLARITY_RESTORATION_TALENT: {
    id: 113043,
    name: 'Omen of Clarity',
    icon: 'spell_nature_crystalball',
    maxRanks: 1,
    entryIds: [128707],
    definitionIds: [{ id: 133509, specId: 105 }],
  },
  ORBITAL_STRIKE_TALENT: {
    id: 390378,
    name: 'Orbital Strike',
    icon: 'ability_druid_cresentburn',
    maxRanks: 1,
    entryIds: [109855],
    definitionIds: [{ id: 114860, specId: 102 }],
  },
  ORBIT_BREAKER_TALENT: {
    id: 383197,
    name: 'Orbit Breaker',
    icon: 'artifactability_balancedruid_moonandstars',
    maxRanks: 1,
    entryIds: [133403],
    definitionIds: [{ id: 138189, specId: 102 }],
  },
  PACKS_ENDURANCE_TALENT: {
    id: 441844,
    name: "Pack's Endurance",
    icon: 'spell_druid_stampedingroar_cat',
    maxRanks: 1,
    entryIds: [117215],
    definitionIds: [{ id: 122227, specId: 104 }],
  },
  PANTHERS_GUILE_TALENT: {
    id: 1280316,
    name: "Panther's Guile",
    icon: 'ability_mount_blackpanther',
    maxRanks: 1,
    entryIds: [103164],
    definitionIds: [{ id: 108169, specId: 103 }],
  },
  PASSING_SEASONS_TALENT: {
    id: 382550,
    name: 'Passing Seasons',
    icon: 'spell_nature_ravenform',
    maxRanks: 1,
    entryIds: [103102],
    definitionIds: [{ id: 108107, specId: 105 }],
  },
  PATIENT_CUSTODIAN_TALENT: {
    id: 1270592,
    name: 'Patient Custodian',
    icon: 'inv_helm_misc_rose_a_01_red',
    maxRanks: 1,
    entryIds: [117232],
    definitionIds: [{ id: 122244, specId: 105 }],
  },
  PENUMBRAL_SWELL_TALENT: {
    id: 1271261,
    name: 'Penumbral Swell',
    icon: 'ability_druid_eclipse',
    maxRanks: 1,
    entryIds: [135977],
    definitionIds: [{ id: 140732, specId: 104 }],
  },
  PERFECTLY_HONED_INSTINCTS_TALENT: {
    id: 1213597,
    name: 'Perfectly-Honed Instincts',
    icon: 'ability_druid_tigersroar',
    maxRanks: 1,
    entryIds: [128586],
    definitionIds: [{ id: 133389, specId: 105 }],
  },
  PERSISTENCE_TALENT: {
    id: 1251406,
    name: 'Persistence',
    icon: 'inv_1115_druid_bearstanding',
    maxRanks: 1,
    entryIds: [103218],
    definitionIds: [{ id: 108223, specId: 104 }],
  },
  PHOTOSYNTHESIS_TALENT: {
    id: 274902,
    name: 'Photosynthesis',
    icon: 'spell_lifegivingseed',
    maxRanks: 1,
    entryIds: [103129],
    definitionIds: [{ id: 108134, specId: 105 }],
  },
  POTENT_ENCHANTMENTS_TALENT: {
    id: 429420,
    name: 'Potent Enchantments',
    icon: 'ability_druid_serenefocus',
    maxRanks: 1,
    entryIds: [117188],
    definitionIds: [{ id: 122200, specId: 105 }],
  },
  POUNCING_STRIKES_TALENT: {
    id: 390772,
    name: 'Pouncing Strikes',
    icon: 'ability_druid_prowl',
    maxRanks: 1,
    entryIds: [103183],
    definitionIds: [{ id: 108188, specId: 103 }],
  },
  POWER_OF_GOLDRINN_TALENT: {
    id: 394046,
    name: 'Power of Goldrinn',
    icon: 'inv_mount_spectralwolf',
    maxRanks: 1,
    entryIds: [109871],
    definitionIds: [{ id: 114876, specId: 102 }],
  },
  POWER_OF_NATURE_TALENT: {
    id: 428859,
    name: 'Power of Nature',
    icon: 'spell_nature_naturesblessing',
    maxRanks: 1,
    entryIds: [117201],
    definitionIds: [{ id: 122213, specId: 105 }],
  },
  POWER_OF_THE_ARCHDRUID_TALENT: {
    id: 392302,
    name: 'Power of the Archdruid',
    icon: 'spell_druid_rampantgrowth',
    maxRanks: 1,
    entryIds: [103121],
    definitionIds: [{ id: 108126, specId: 105 }],
  },
  POWER_OF_THE_DREAM_TALENT: {
    id: 434220,
    name: 'Power of the Dream',
    icon: 'ability_xavius_dreamsimulacrum',
    maxRanks: 1,
    entryIds: [117185],
    definitionIds: [{ id: 122197, specId: 105 }],
  },
  PREDATOR_TALENT: {
    id: 202021,
    name: 'Predator',
    icon: 'ability_hunter_catlikereflexes',
    maxRanks: 1,
    entryIds: [103186],
    definitionIds: [{ id: 108191, specId: 103 }],
  },
  PRIMAL_FURY_TALENT: {
    id: 159286,
    name: 'Primal Fury',
    icon: 'ability_racial_cannibalize',
    maxRanks: 1,
    entryIds: [103302],
    definitionIds: [{ id: 108307, specId: 105 }],
  },
  PRIMAL_WRATH_TALENT: {
    id: 285381,
    name: 'Primal Wrath',
    icon: 'artifactability_feraldruid_ashamanesbite',
    maxRanks: 1,
    entryIds: [103184],
    definitionIds: [{ id: 108189, specId: 103 }],
    energyCost: 25,
    comboPointsCost: 1,
  },
  PROSPERITY_TALENT: {
    id: 200383,
    name: 'Prosperity',
    icon: 'ability_druid_giftoftheearthmother',
    maxRanks: 1,
    entryIds: [103136],
    definitionIds: [{ id: 108141, specId: 105 }],
  },
  PROTECTIVE_GROWTH_TALENT: {
    id: 433748,
    name: 'Protective Growth',
    icon: 'spell_nature_resistnature',
    maxRanks: 1,
    entryIds: [117186],
    definitionIds: [{ id: 122198, specId: 105 }],
  },
  RADIANT_MOONLIGHT_TALENT: {
    id: 394121,
    name: 'Radiant Moonlight',
    icon: 'artifactability_balancedruid_fullmoon',
    maxRanks: 1,
    entryIds: [109847],
    definitionIds: [{ id: 114852, specId: 102 }],
  },
  RAGING_FURY_TALENT: {
    id: 391078,
    name: 'Raging Fury',
    icon: 'ability_druid_predatoryinstincts',
    maxRanks: 1,
    entryIds: [103169],
    definitionIds: [{ id: 108174, specId: 103 }],
  },
  RAKE_TALENT: {
    id: 1822,
    name: 'Rake',
    icon: 'ability_druid_disembowel',
    maxRanks: 1,
    entryIds: [103277],
    definitionIds: [{ id: 108282, specId: 105 }],
    energyCost: 35,
  },
  RAMPANCY_TALENT: {
    id: 1270586,
    name: 'Rampancy',
    icon: 'inv_misc_thornnecklace',
    maxRanks: 1,
    entryIds: [135973],
    definitionIds: [{ id: 140728, specId: 105 }],
  },
  RAMPANT_FEROCITY_TALENT: {
    id: 391709,
    name: 'Rampant Ferocity',
    icon: 'ability_druid_primaltenacity',
    maxRanks: 1,
    entryIds: [103181],
    definitionIds: [{ id: 108186, specId: 103 }],
  },
  RAMPANT_GROWTH_TALENT: {
    id: 404521,
    name: 'Rampant Growth',
    icon: 'spell_nature_resistnature',
    maxRanks: 1,
    entryIds: [103112],
    definitionIds: [{ id: 108117, specId: 105 }],
  },
  RATTLE_THE_STARS_TALENT: {
    id: 393954,
    name: 'Rattle the Stars',
    icon: 'spell_arcane_arcane01',
    maxRanks: 1,
    entryIds: [109872],
    definitionIds: [{ id: 114877, specId: 102 }],
  },
  RAVAGE_TALENT: {
    id: 441583,
    name: 'Ravage',
    icon: 'inv_ability_druidoftheclawdruid_ravage',
    maxRanks: 1,
    entryIds: [117206],
    definitionIds: [{ id: 122218, specId: 104 }],
  },
  RAZE_TALENT: {
    id: 400254,
    name: 'Raze',
    icon: 'ability_druid_lacerate',
    maxRanks: 1,
    entryIds: [103202],
    definitionIds: [{ id: 108207, specId: 104 }],
    rageCost: 40,
  },
  RED_MOON_TALENT: {
    id: 1252871,
    name: 'Red Moon',
    icon: 'sha_ability_mage_firestarter_nightmare',
    maxRanks: 1,
    entryIds: [135336],
    definitionIds: [{ id: 140103, specId: 104 }],
  },
  REFORESTATION_TALENT: {
    id: 392356,
    name: 'Reforestation',
    icon: 'inv_herbalism_70_yserallineseed',
    maxRanks: 1,
    entryIds: [103125],
    definitionIds: [{ id: 108130, specId: 105 }],
  },
  REGENERATIVE_HEARTWOOD_TALENT: {
    id: 392116,
    name: 'Regenerative Heartwood',
    icon: 'spell_nature_naturetouchgrow',
    maxRanks: 1,
    entryIds: [103131],
    definitionIds: [{ id: 108136, specId: 105 }],
  },
  REGENESIS_TALENT: {
    id: 383191,
    name: 'Regenesis',
    icon: 'inv_misc_herb_liferoot_stem',
    maxRanks: 2,
    entryIds: [103117],
    definitionIds: [{ id: 108122, specId: 105 }],
  },
  REINFORCED_FUR_TALENT: {
    id: 393618,
    name: 'Reinforced Fur',
    icon: 'spell_nature_spiritarmor',
    maxRanks: 1,
    entryIds: [103231],
    definitionIds: [{ id: 108236, specId: 104 }],
  },
  REINVIGORATION_TALENT: {
    id: 372945,
    name: 'Reinvigoration',
    icon: 'ability_druid_overgrowth',
    maxRanks: 2,
    entryIds: [103226],
    definitionIds: [{ id: 108231, specId: 104 }],
  },
  REJUVENATION_TALENT: {
    id: 774,
    name: 'Rejuvenation',
    icon: 'spell_nature_rejuvenation',
    maxRanks: 1,
    entryIds: [103295],
    definitionIds: [{ id: 108300, specId: 105 }],
    manaCost: 5250,
  },
  REMOVE_CORRUPTION_TALENT: {
    id: 2782,
    name: 'Remove Corruption',
    icon: 'spell_holy_removecurse',
    maxRanks: 1,
    entryIds: [103320],
    definitionIds: [{ id: 108325, specId: 104 }],
    manaCost: 25000,
  },
  REND_AND_TEAR_TALENT: {
    id: 204053,
    name: 'Rend and Tear',
    icon: 'ability_druid_swipe',
    maxRanks: 1,
    entryIds: [103221],
    definitionIds: [{ id: 108226, specId: 104 }],
  },
  RENEWING_SURGE_TALENT: {
    id: 470562,
    name: 'Renewing Surge',
    icon: 'inv_relics_idolofhealth',
    maxRanks: 1,
    entryIds: [103114],
    definitionIds: [{ id: 108119, specId: 105 }],
  },
  RESILIENT_FLOURISHING_TALENT: {
    id: 439880,
    name: 'Resilient Flourishing',
    icon: 'inv_misc_herb_16',
    maxRanks: 1,
    entryIds: [117234],
    definitionIds: [{ id: 122246, specId: 105 }],
  },
  RIP_AND_TEAR_TALENT: {
    id: 391347,
    name: 'Rip and Tear',
    icon: 'ability_ghoulfrenzy',
    maxRanks: 1,
    entryIds: [103153],
    definitionIds: [{ id: 108158, specId: 103 }],
  },
  RIP_TALENT: {
    id: 1079,
    name: 'Rip',
    icon: 'ability_ghoulfrenzy',
    maxRanks: 1,
    entryIds: [103300],
    definitionIds: [{ id: 108305, specId: 105 }],
    energyCost: 20,
    comboPointsCost: 1,
  },
  ROOT_NETWORK_TALENT: {
    id: 439882,
    name: 'Root Network',
    icon: 'ability_creature_poison_04',
    maxRanks: 1,
    entryIds: [117233],
    definitionIds: [{ id: 122245, specId: 105 }],
  },
  RUTHLESS_AGGRESSION_TALENT: {
    id: 441814,
    name: 'Ruthless Aggression',
    icon: 'ability_druid_rake',
    maxRanks: 1,
    entryIds: [135981],
    definitionIds: [{ id: 140736, specId: 104 }],
  },
  SABERTOOTH_TALENT: {
    id: 202031,
    name: 'Sabertooth',
    icon: 'inv_misc_monsterfang_01',
    maxRanks: 1,
    entryIds: [103163],
    definitionIds: [{ id: 108168, specId: 103 }],
  },
  SABER_JAWS_TALENT: {
    id: 421432,
    name: 'Saber Jaws',
    icon: 'inv_misc_monsterfang_02',
    maxRanks: 2,
    entryIds: [103155],
    definitionIds: [{ id: 108160, specId: 103 }],
  },
  SAVAGE_FURY_TALENT: {
    id: 449645,
    name: 'Savage Fury',
    icon: 'ability_druid_kingofthejungle',
    maxRanks: 1,
    entryIds: [103160],
    definitionIds: [{ id: 108165, specId: 103 }],
  },
  SCINTILLATING_MOONLIGHT_TALENT: {
    id: 238049,
    name: 'Scintillating Moonlight',
    icon: 'spell_fire_twilightfireward',
    maxRanks: 2,
    entryIds: [103213],
    definitionIds: [{ id: 108218, specId: 104 }],
  },
  SCULPT_THE_STARS_TALENT: {
    id: 1240188,
    name: 'Sculpt the Stars',
    icon: 'ability_druid_eclipseorange',
    maxRanks: 1,
    entryIds: [117100],
    definitionIds: [{ id: 122112, specId: 102 }],
  },
  SHOOTING_STARS_TALENT: {
    id: 202342,
    name: 'Shooting Stars',
    icon: 'spell_priest_divinestar_shadow2',
    maxRanks: 1,
    entryIds: [109861],
    definitionIds: [{ id: 114866, specId: 102 }],
  },
  SKULL_BASH_TALENT: {
    id: 106839,
    name: 'Skull Bash',
    icon: 'inv_bone_skull_04',
    maxRanks: 1,
    entryIds: [103322],
    definitionIds: [{ id: 108327, specId: 104 }],
  },
  SOLAR_BEAM_TALENT: {
    id: 78675,
    name: 'Solar Beam',
    icon: 'ability_vehicle_sonicshockwave',
    maxRanks: 1,
    entryIds: [109867],
    definitionIds: [{ id: 114872, specId: 102 }],
    manaCost: 8400,
  },
  SOLSTICE_TALENT: {
    id: 343647,
    name: 'Solstice',
    icon: 'artifactability_balancedruid_moonandstars',
    maxRanks: 1,
    entryIds: [109835],
    definitionIds: [{ id: 114840, specId: 102 }],
  },
  SOOTHE_TALENT: {
    id: 2908,
    name: 'Soothe',
    icon: 'ability_hunter_beastsoothe',
    maxRanks: 1,
    entryIds: [103307],
    definitionIds: [{ id: 108312, specId: 105 }],
    manaCost: 2800,
  },
  SOUL_OF_THE_FOREST_BALANCE_TALENT: {
    id: 114107,
    name: 'Soul of the Forest',
    icon: 'ability_druid_manatree',
    maxRanks: 1,
    entryIds: [109853],
    definitionIds: [{ id: 114858, specId: 102 }],
  },
  SOUL_OF_THE_FOREST_FERAL_TALENT: {
    id: 158476,
    name: 'Soul of the Forest',
    icon: 'ability_druid_manatree',
    maxRanks: 1,
    entryIds: [103150],
    definitionIds: [{ id: 108155, specId: 103 }],
  },
  SOUL_OF_THE_FOREST_GUARDIAN_TALENT: {
    id: 158477,
    name: 'Soul of the Forest',
    icon: 'ability_druid_manatree',
    maxRanks: 1,
    entryIds: [103208],
    definitionIds: [{ id: 108213, specId: 104 }],
  },
  SOUL_OF_THE_FOREST_RESTORATION_TALENT: {
    id: 158478,
    name: 'Soul of the Forest',
    icon: 'ability_druid_manatree',
    maxRanks: 1,
    entryIds: [103109],
    definitionIds: [{ id: 108114, specId: 105 }],
  },
  SPIRIT_OF_THE_THICKET_TALENT: {
    id: 1264899,
    name: 'Spirit of the Thicket',
    icon: 'ability_druid_naturalperfection',
    maxRanks: 1,
    entryIds: [135970],
    definitionIds: [{ id: 140725, specId: 105 }],
  },
  STAMPEDING_ROAR_TALENT: {
    id: 106898,
    name: 'Stampeding Roar',
    icon: 'spell_druid_stampedingroar_cat',
    maxRanks: 1,
    entryIds: [103312],
    definitionIds: [{ id: 108317, specId: 105 }],
  },
  STARFIRE_BALANCE_TALENT: {
    id: 194153,
    name: 'Starfire',
    icon: 'spell_arcane_starfire',
    maxRanks: 1,
    entryIds: [103279],
    definitionIds: [{ id: 108284, specId: 102 }],
  },
  STARFIRE_SHARED_TALENT: {
    id: 197628,
    name: 'Starfire',
    icon: 'spell_arcane_starfire',
    maxRanks: 1,
    entryIds: [112967],
    definitionIds: [{ id: 117972, specId: 105 }],
  },
  STARLIGHT_CONDUIT_TALENT: {
    id: 451211,
    name: 'Starlight Conduit',
    icon: 'spell_arcane_arcane01',
    maxRanks: 1,
    entryIds: [123868],
    definitionIds: [{ id: 128706, specId: 105 }],
  },
  STARLORD_TALENT: {
    id: 202345,
    name: 'Starlord',
    icon: 'spell_shaman_measuredinsight',
    maxRanks: 2,
    entryIds: [109840],
    definitionIds: [{ id: 114845, specId: 102 }],
  },
  STARSURGE_BALANCE_TALENT: {
    id: 78674,
    name: 'Starsurge',
    icon: 'spell_arcane_arcane03',
    maxRanks: 1,
    entryIds: [103280],
    definitionIds: [{ id: 108285, specId: 102 }],
    lunarPowerCost: 400,
  },
  STARSURGE_SHARED_TALENT: {
    id: 197626,
    name: 'Starsurge',
    icon: 'spell_arcane_arcane03',
    maxRanks: 1,
    entryIds: [103278],
    definitionIds: [{ id: 108283, specId: 105 }],
  },
  STARWEAVER_TALENT: {
    id: 393940,
    name: 'Starweaver',
    icon: 'spell_arcane_invocation',
    maxRanks: 1,
    entryIds: [109873],
    definitionIds: [{ id: 114878, specId: 102 }],
  },
  STAR_CASCADE_TALENT: {
    id: 1271206,
    name: 'Star Cascade',
    icon: 'spell_arcane_arcane03',
    maxRanks: 1,
    entryIds: [135978],
    definitionIds: [{ id: 140733, specId: 104 }],
  },
  STELLAR_AMPLIFICATION_TALENT: {
    id: 450212,
    name: 'Stellar Amplification',
    icon: 'spell_arcane_arcane04',
    maxRanks: 1,
    entryIds: [109846],
    definitionIds: [{ id: 114851, specId: 102 }],
  },
  STELLAR_COMMAND_TALENT: {
    id: 429668,
    name: 'Stellar Command',
    icon: 'artifactability_balancedruid_moonandstars',
    maxRanks: 1,
    entryIds: [117190],
    definitionIds: [{ id: 122202, specId: 104 }],
  },
  STONEBARK_TALENT: {
    id: 197061,
    name: 'Stonebark',
    icon: 'archaeology_5_0_crackedmogurunestone',
    maxRanks: 1,
    entryIds: [103140],
    definitionIds: [{ id: 108145, specId: 105 }],
  },
  STRATEGIC_INFUSION_TALENT: {
    id: 439890,
    name: 'Strategic Infusion',
    icon: 'ability_druid_supriseattack',
    maxRanks: 1,
    entryIds: [117223],
    definitionIds: [{ id: 122235, specId: 105 }],
  },
  STRIKE_FOR_THE_HEART_TALENT: {
    id: 441845,
    name: 'Strike for the Heart',
    icon: 'ability_druid_primalagression',
    maxRanks: 1,
    entryIds: [117214],
    definitionIds: [{ id: 122226, specId: 104 }],
  },
  SUDDEN_AMBUSH_TALENT: {
    id: 384667,
    name: 'Sudden Ambush',
    icon: 'ability_hunter_catlikereflexes',
    maxRanks: 1,
    entryIds: [114771],
    definitionIds: [{ id: 119778, specId: 103 }],
  },
  SUNDERED_FIRMAMENT_TALENT: {
    id: 394094,
    name: 'Sundered Firmament',
    icon: 'spell_druid_equinox',
    maxRanks: 1,
    entryIds: [109852],
    definitionIds: [{ id: 114857, specId: 102 }],
  },
  SUNDERING_ROAR_TALENT: {
    id: 1253799,
    name: 'Sundering Roar',
    icon: 'artifactability_feraldruid_openwounds',
    maxRanks: 1,
    entryIds: [114701],
    definitionIds: [{ id: 119707, specId: 104 }],
  },
  SUNFIRE_TALENT: {
    id: 93402,
    name: 'Sunfire',
    icon: 'ability_mage_firestarter',
    maxRanks: 1,
    entryIds: [116102],
    definitionIds: [{ id: 121114, specId: 105 }],
    manaCost: 4500,
  },
  SUNSEEKER_MUSHROOM_TALENT: {
    id: 468936,
    name: 'Sunseeker Mushroom',
    icon: 'druid_ability_wildmushroom_b',
    maxRanks: 1,
    entryIds: [109834],
    definitionIds: [{ id: 114839, specId: 102 }],
  },
  SURVIVAL_INSTINCTS_TALENT: {
    id: 61336,
    name: 'Survival Instincts',
    icon: 'ability_druid_tigersroar',
    maxRanks: 1,
    entryIds: [103180, 103193],
    definitionIds: [
      { id: 108185, specId: 103 },
      { id: 108198, specId: 104 },
    ],
  },
  SURVIVAL_OF_THE_FITTEST_TALENT: {
    id: 203965,
    name: 'Survival of the Fittest',
    icon: 'ability_druid_enrage',
    maxRanks: 2,
    entryIds: [103210],
    definitionIds: [{ id: 108215, specId: 104 }],
  },
  SWIFTMEND_TALENT: {
    id: 18562,
    name: 'Swiftmend',
    icon: 'inv_relics_idolofrejuvenation',
    maxRanks: 1,
    entryIds: [103098],
    definitionIds: [{ id: 108103, specId: 105 }],
    manaCost: 3500,
  },
  SWIPE_TALENT: {
    id: 213764,
    name: 'Swipe',
    icon: 'inv_misc_monsterclaw_03',
    maxRanks: 1,
    entryIds: [103301],
    definitionIds: [{ id: 108306, specId: 105 }],
  },
  SYLVAN_BECKONING_TALENT: {
    id: 1264614,
    name: 'Sylvan Beckoning',
    icon: 'ui_darkshore_warfront_alliance_dryad',
    maxRanks: 1,
    entryIds: [135972],
    definitionIds: [{ id: 140727, specId: 105 }],
  },
  SYMBIOTIC_RELATIONSHIP_TALENT: {
    id: 474750,
    name: 'Symbiotic Relationship',
    icon: 'ability_druid_focusedgrowth',
    maxRanks: 1,
    entryIds: [123792],
    definitionIds: [{ id: 128630, specId: 105 }],
    manaCost: 5000,
  },
  TASTE_FOR_BLOOD_TALENT: {
    id: 384665,
    name: 'Taste for Blood',
    icon: 'ability_druid_ferociousbite',
    maxRanks: 1,
    entryIds: [103165],
    definitionIds: [{ id: 108170, specId: 103 }],
  },
  TEAR_DOWN_THE_MIGHTY_TALENT: {
    id: 441846,
    name: 'Tear Down the Mighty',
    icon: 'inv_1115_druid_jaguar',
    maxRanks: 1,
    entryIds: [117213],
    definitionIds: [{ id: 122225, specId: 104 }],
  },
  THE_ETERNAL_MOON_TALENT: {
    id: 424113,
    name: 'The Eternal Moon',
    icon: 'artifactability_balancedruid_newmoon',
    maxRanks: 1,
    entryIds: [117179],
    definitionIds: [{ id: 122191, specId: 104 }],
  },
  THE_LIGHT_OF_ELUNE_TALENT: {
    id: 428655,
    name: 'The Light of Elune',
    icon: 'ability_druid_dreamstate',
    maxRanks: 1,
    entryIds: [117176],
    definitionIds: [{ id: 122188, specId: 104 }],
  },
  THICK_HIDE_TALENT: {
    id: 16931,
    name: 'Thick Hide',
    icon: 'inv_misc_pelt_bear_03',
    maxRanks: 1,
    entryIds: [103306],
    definitionIds: [{ id: 108311, specId: 105 }],
  },
  THRIVING_GROWTH_TALENT: {
    id: 439528,
    name: 'Thriving Growth',
    icon: 'inv_ability_wildstalkerdruid_thrivinggrowth',
    maxRanks: 1,
    entryIds: [117226],
    definitionIds: [{ id: 122238, specId: 105 }],
  },
  THRIVING_VEGETATION_TALENT: {
    id: 447131,
    name: 'Thriving Vegetation',
    icon: 'spell_nature_rejuvenation',
    maxRanks: 2,
    entryIds: [103124],
    definitionIds: [{ id: 108129, specId: 105 }],
  },
  TIGERS_FURY_TALENT: {
    id: 5217,
    name: "Tiger's Fury",
    icon: 'ability_mount_jungletiger',
    maxRanks: 1,
    entryIds: [103188],
    definitionIds: [{ id: 108193, specId: 103 }],
  },
  TIGERS_TENACITY_TALENT: {
    id: 391872,
    name: "Tiger's Tenacity",
    icon: 'ability_druid_healinginstincts',
    maxRanks: 1,
    entryIds: [103168],
    definitionIds: [{ id: 108173, specId: 103 }],
  },
  TIGER_DASH_TALENT: {
    id: 252216,
    name: 'Tiger Dash',
    icon: 'ability_druid_dash_orange',
    maxRanks: 1,
    entryIds: [103275],
    definitionIds: [{ id: 108280, specId: 105 }],
  },
  TIRELESS_ENERGY_TALENT: {
    id: 383352,
    name: 'Tireless Energy',
    icon: 'spell_chargepositive',
    maxRanks: 2,
    entryIds: [103185],
    definitionIds: [{ id: 108190, specId: 103 }],
  },
  TOTAL_ECLIPSE_TALENT: {
    id: 1240206,
    name: 'Total Eclipse',
    icon: 'inv12_ability_druid_totaleclipse',
    maxRanks: 2,
    entryIds: [109832],
    definitionIds: [{ id: 114837, specId: 102 }],
  },
  TOUCH_THE_COSMOS_TALENT: {
    id: 450356,
    name: 'Touch the Cosmos',
    icon: 'ability_bossgorefiend_touchofdoom',
    maxRanks: 1,
    entryIds: [109857],
    definitionIds: [{ id: 114862, specId: 102 }],
  },
  TRANQUILITY_TALENT: {
    id: 740,
    name: 'Tranquility',
    icon: 'spell_nature_tranquility',
    maxRanks: 1,
    entryIds: [103108],
    definitionIds: [{ id: 108113, specId: 105 }],
    manaCost: 9200,
  },
  TRANQUIL_MIND_TALENT: {
    id: 403521,
    name: 'Tranquil Mind',
    icon: 'ability_druid_serenefocus',
    maxRanks: 1,
    entryIds: [114808],
    definitionIds: [{ id: 119815, specId: 105 }],
  },
  TREANTS_OF_THE_MOON_TALENT: {
    id: 428544,
    name: 'Treants of the Moon',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [117194],
    definitionIds: [{ id: 122206, specId: 105 }],
  },
  TWIN_CLAW_TALENT: {
    id: 1271635,
    name: 'Twin Claw',
    icon: 'ability_druid_swipe',
    maxRanks: 1,
    entryIds: [135979],
    definitionIds: [{ id: 140734, specId: 104 }],
  },
  TWIN_MOONFIRE_TALENT: {
    id: 372567,
    name: 'Twin Moonfire',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [103214],
    definitionIds: [{ id: 108219, specId: 104 }],
  },
  TWIN_MOONS_TALENT: {
    id: 279620,
    name: 'Twin Moons',
    icon: 'spell_nature_starfall',
    maxRanks: 1,
    entryIds: [109833],
    definitionIds: [{ id: 114838, specId: 102 }],
  },
  TWIN_SPROUTS_TALENT: {
    id: 440117,
    name: 'Twin Sprouts',
    icon: 'inv_misc_herb_evergreenmoss',
    maxRanks: 1,
    entryIds: [117230],
    definitionIds: [{ id: 122242, specId: 105 }],
  },
  TYPHOON_TALENT: {
    id: 132469,
    name: 'Typhoon',
    icon: 'ability_druid_typhoon',
    maxRanks: 1,
    entryIds: [103287],
    definitionIds: [{ id: 108292, specId: 105 }],
  },
  UMBRAL_EMBRACE_TALENT: {
    id: 393760,
    name: 'Umbral Embrace',
    icon: 'ability_druid_improvedmoonkinform',
    maxRanks: 1,
    entryIds: [109870],
    definitionIds: [{ id: 114875, specId: 102 }],
  },
  UMBRAL_INTENSITY_TALENT: {
    id: 383195,
    name: 'Umbral Intensity',
    icon: 'ability_druid_eclipse',
    maxRanks: 1,
    entryIds: [109842],
    definitionIds: [{ id: 114847, specId: 102 }],
  },
  UNSEEN_PREDATOR_1_FERAL_TALENT: {
    id: 1263657,
    name: 'Unseen Predator',
    icon: 'inv12_apextalent_druid_unseenpredator',
    maxRanks: 1,
    entryIds: [137046],
    definitionIds: [{ id: 141809, specId: 103 }],
  },
  UNSEEN_PREDATOR_2_FERAL_TALENT: {
    id: 1263658,
    name: 'Unseen Predator',
    icon: 'inv12_apextalent_druid_unseenpredator',
    maxRanks: 2,
    entryIds: [137045],
    definitionIds: [{ id: 141808, specId: 103 }],
  },
  UNSEEN_PREDATOR_3_FERAL_TALENT: {
    id: 1263660,
    name: 'Unseen Predator',
    icon: 'inv12_apextalent_druid_unseenpredator',
    maxRanks: 1,
    entryIds: [137044],
    definitionIds: [{ id: 141807, specId: 103 }],
  },
  UNSTOPPABLE_GROWTH_TALENT: {
    id: 382559,
    name: 'Unstoppable Growth',
    icon: 'ability_druid_flourish',
    maxRanks: 2,
    entryIds: [103138],
    definitionIds: [{ id: 108143, specId: 105 }],
  },
  UNTAMED_SAVAGERY_TALENT: {
    id: 372943,
    name: 'Untamed Savagery',
    icon: 'spell_druid_bloodythrash',
    maxRanks: 1,
    entryIds: [103220],
    definitionIds: [{ id: 108225, specId: 104 }],
  },
  URSINE_VIGOR_TALENT: {
    id: 377842,
    name: 'Ursine Vigor',
    icon: 'ability_druid_markofursol',
    maxRanks: 1,
    entryIds: [123793],
    definitionIds: [{ id: 128631, specId: 105 }],
  },
  URSOCS_ENDURANCE_TALENT: {
    id: 393611,
    name: "Ursoc's Endurance",
    icon: 'ability_hunter_pet_bear',
    maxRanks: 1,
    entryIds: [135568],
    definitionIds: [{ id: 140324, specId: 104 }],
  },
  URSOCS_FURY_TALENT: {
    id: 377210,
    name: "Ursoc's Fury",
    icon: 'achievement_emeraldnightmare_ursoc',
    maxRanks: 1,
    entryIds: [103228],
    definitionIds: [{ id: 108233, specId: 104 }],
  },
  URSOCS_GUIDANCE_TALENT: {
    id: 393414,
    name: "Ursoc's Guidance",
    icon: 'inv_ability_druid_convokethespirits',
    maxRanks: 1,
    entryIds: [103199],
    definitionIds: [{ id: 108204, specId: 104 }],
  },
  URSOCS_SPIRIT_TALENT: {
    id: 449182,
    name: "Ursoc's Spirit",
    icon: 'spell_nature_spiritarmor',
    maxRanks: 1,
    entryIds: [103297],
    definitionIds: [{ id: 108302, specId: 105 }],
  },
  URSOLS_VORTEX_TALENT: {
    id: 102793,
    name: "Ursol's Vortex",
    icon: 'spell_druid_ursolsvortex',
    maxRanks: 1,
    entryIds: [128589],
    definitionIds: [{ id: 133392, specId: 105 }],
  },
  URSOLS_WARDING_TALENT: {
    id: 471492,
    name: "Ursol's Warding",
    icon: 'spell_nature_natureresistancetotem',
    maxRanks: 1,
    entryIds: [103215],
    definitionIds: [{ id: 108220, specId: 104 }],
  },
  VEINRIPPER_TALENT: {
    id: 391978,
    name: 'Veinripper',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [103154],
    definitionIds: [{ id: 108159, specId: 103 }],
  },
  VERDANCY_TALENT: {
    id: 392325,
    name: 'Verdancy',
    icon: 'inv_10_herb_seed_magiccolor5',
    maxRanks: 1,
    entryIds: [103113],
    definitionIds: [{ id: 108118, specId: 105 }],
  },
  VERDANT_HEART_TALENT: {
    id: 301768,
    name: 'Verdant Heart',
    icon: 'ability_bullrush',
    maxRanks: 1,
    entryIds: [103296],
    definitionIds: [{ id: 108301, specId: 105 }],
  },
  VERDANT_INFUSION_TALENT: {
    id: 392410,
    name: 'Verdant Infusion',
    icon: 'inv_relics_totemoflife',
    maxRanks: 1,
    entryIds: [103137],
    definitionIds: [{ id: 108142, specId: 105 }],
  },
  VIGOROUS_CREEPERS_TALENT: {
    id: 440119,
    name: 'Vigorous Creepers',
    icon: 'spell_druid_massentanglement',
    maxRanks: 1,
    entryIds: [117227],
    definitionIds: [{ id: 122239, specId: 105 }],
  },
  VULNERABLE_FLESH_TALENT: {
    id: 372618,
    name: 'Vulnerable Flesh',
    icon: 'ability_druid_primalagression',
    maxRanks: 1,
    entryIds: [103195],
    definitionIds: [{ id: 108200, specId: 104 }],
  },
  WAKING_DREAM_TALENT: {
    id: 392221,
    name: 'Waking Dream',
    icon: 'inv_misc_head_dragon_green',
    maxRanks: 1,
    entryIds: [103097],
    definitionIds: [{ id: 108102, specId: 105 }],
  },
  WAKING_NIGHTMARE_TALENT: {
    id: 1253461,
    name: 'Waking Nightmare',
    icon: 'sha_spell_shadow_shadesofdarkness_nightmare',
    maxRanks: 1,
    entryIds: [135488],
    definitionIds: [{ id: 140245, specId: 104 }],
  },
  WARD_OF_THE_FOREST_TALENT: {
    id: 1250923,
    name: 'Ward of the Forest',
    icon: 'achievement_zone_grizzlyhills_01',
    maxRanks: 1,
    entryIds: [135337],
    definitionIds: [{ id: 140104, specId: 104 }],
  },
  WELL_HONED_INSTINCTS_TALENT: {
    id: 377847,
    name: 'Well-Honed Instincts',
    icon: 'ability_druid_tigersroar',
    maxRanks: 1,
    entryIds: [103313],
    definitionIds: [{ id: 108318, specId: 105 }],
  },
  WHIRLING_STARS_TALENT: {
    id: 468743,
    name: 'Whirling Stars',
    icon: 'spell_druid_equinox',
    maxRanks: 1,
    entryIds: [109856],
    definitionIds: [{ id: 114861, specId: 102 }],
  },
  WILDPOWER_SURGE_TALENT: {
    id: 441691,
    name: 'Wildpower Surge',
    icon: 'ability_druid_ravage',
    maxRanks: 1,
    entryIds: [117209],
    definitionIds: [{ id: 122221, specId: 104 }],
  },
  WILDSHAPE_MASTERY_TALENT: {
    id: 441678,
    name: 'Wildshape Mastery',
    icon: 'ability_druid_mastershapeshifter',
    maxRanks: 1,
    entryIds: [117207],
    definitionIds: [{ id: 122219, specId: 104 }],
  },
  WILDSTALKERS_POWER_TALENT: {
    id: 439926,
    name: "Wildstalker's Power",
    icon: 'ability_druid_skinteeth',
    maxRanks: 1,
    entryIds: [117221],
    definitionIds: [{ id: 122233, specId: 105 }],
  },
  WILD_CHARGE_TALENT: {
    id: 102401,
    name: 'Wild Charge',
    icon: 'spell_druid_wildcharge',
    maxRanks: 1,
    entryIds: [103276],
    definitionIds: [{ id: 108281, specId: 105 }],
  },
  WILD_GROWTH_TALENT: {
    id: 48438,
    name: 'Wild Growth',
    icon: 'ability_druid_flourish',
    maxRanks: 1,
    entryIds: [103283],
    definitionIds: [{ id: 108288, specId: 105 }],
    manaCost: 9500,
  },
  WILD_GUARDIAN_1_GUARDIAN_TALENT: {
    id: 1269614,
    name: 'Wild Guardian',
    icon: 'inv12_apextalent_druid_wildguardian',
    maxRanks: 1,
    entryIds: [137061],
    definitionIds: [{ id: 141824, specId: 104 }],
  },
  WILD_GUARDIAN_2_GUARDIAN_TALENT: {
    id: 1269617,
    name: 'Wild Guardian',
    icon: 'inv12_apextalent_druid_wildguardian',
    maxRanks: 2,
    entryIds: [137060],
    definitionIds: [{ id: 141823, specId: 104 }],
  },
  WILD_GUARDIAN_3_GUARDIAN_TALENT: {
    id: 1269619,
    name: 'Wild Guardian',
    icon: 'inv12_apextalent_druid_wildguardian',
    maxRanks: 1,
    entryIds: [137059],
    definitionIds: [{ id: 141822, specId: 104 }],
  },
  WILD_MUSHROOM_TALENT: {
    id: 88747,
    name: 'Wild Mushroom',
    icon: 'druid_ability_wildmushroom_a',
    maxRanks: 1,
    entryIds: [128232],
    definitionIds: [{ id: 133039, specId: 102 }],
  },
  WILD_SLASHES_TALENT: {
    id: 390864,
    name: 'Wild Slashes',
    icon: 'ability_xavius_tormentingswipe',
    maxRanks: 1,
    entryIds: [103166],
    definitionIds: [{ id: 108171, specId: 103 }],
  },
  WILD_SURGES_TALENT: {
    id: 406890,
    name: 'Wild Surges',
    icon: 'ability_skyreach_lens_flare',
    maxRanks: 1,
    entryIds: [109836],
    definitionIds: [{ id: 114841, specId: 102 }],
  },
  WILD_SYNTHESIS_TALENT: {
    id: 400533,
    name: 'Wild Synthesis',
    icon: 'spell_nature_protectionformnature',
    maxRanks: 1,
    entryIds: [117105],
    definitionIds: [{ id: 122117, specId: 105 }],
  },
  YSERAS_GIFT_TALENT: {
    id: 145108,
    name: "Ysera's Gift",
    icon: 'inv_misc_head_dragon_green',
    maxRanks: 1,
    entryIds: [103099],
    definitionIds: [{ id: 108104, specId: 105 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_DRUID };
